import React, { useState } from "react";

export default function ConsultationModal({ onClose }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    date: "",
    time: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch("submit_consultation.php", {
      method: "POST",
      body: new URLSearchParams(form),
    });
    const result = await response.text();
    alert(result);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-full max-w-lg mx-4 p-6 rounded-lg shadow-lg relative">
        <button
          onClick={onClose}
          className="absolute top-6 right-6 text-gray-500 hover:text-gray-800 text-2xl"
        >
          &times;
        </button>

        <form onSubmit={handleSubmit} className="space-y-4">
          <h2 className="text-2xl font-semibold text-center">
            Book A Consultation
          </h2>

          {["name", "email", "mobile", "date", "time"].map((field, idx) => (
            <div key={idx}>
              <label className="block text-sm font-medium mb-1">
                <span className="text-red-500">*</span>{" "}
                {field.charAt(0).toUpperCase() + field.slice(1)}
              </label>
              <input
                type={
                  field === "email"
                    ? "email"
                    : field === "date"
                    ? "date"
                    : field === "time"
                    ? "time"
                    : "text"
                }
                name={field}
                value={form[field]}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          ))}

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-400 text-gray-700 rounded hover:bg-gray-100"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-[#0c1a2b] text-white px-4 py-2 rounded hover:bg-[#132c47]"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
